import { type TooltipPlacement } from "antd/lib/tooltip";
import moment from "moment";
import { type FunctionComponent, useContext } from "react";

import { AppDefaultInfoContext } from "helpers/globalContext/AppDefaultInfoContext";

import { BTLoginTypes } from "types/enum";

import { BTFormattedPlural } from "commonComponents/btWrappers/BTFormattedPlural/BTFormattedPlural";
import { BTPopover } from "commonComponents/btWrappers/BTPopover/BTPopover";

interface IReminderPopoverProps {
    loginType: BTLoginTypes;
    placement?: TooltipPlacement;
}

export const ReminderPopover: FunctionComponent<IReminderPopoverProps> = ({
    loginType,
    placement = "top",
}) => {
    const appDefaultInfo = useContext(AppDefaultInfoContext);
    let intervalInMinutes;
    let maxDaysInMinutes;
    switch (loginType) {
        case BTLoginTypes.BUILDER:
            intervalInMinutes =
                appDefaultInfo?.internalUserActivationReminderIntervalInMinutes ?? 4320;
            maxDaysInMinutes =
                appDefaultInfo?.internalUserActivationReminderMaxDaysInMinutes ?? 43200;
            break;
        case BTLoginTypes.SUBS:
            intervalInMinutes = appDefaultInfo?.subActivationReminderIntervalInMinutes ?? 4320;
            maxDaysInMinutes = appDefaultInfo?.subActivationReminderMaxDaysInMinutes ?? 43200;
            break;
        default:
            intervalInMinutes = 4320;
            maxDaysInMinutes = 43200;
            break;
    }

    const intervalInDays = moment.duration(intervalInMinutes, "minutes").asDays();
    const timePeriod = moment.duration(maxDaysInMinutes, "minutes").asDays();

    if (intervalInDays === 0 || maxDaysInMinutes === 0) {
        return <></>;
    }

    return (
        <BTPopover
            content={
                <>
                    Reminder email will be sent every {intervalInDays}&nbsp;
                    <BTFormattedPlural value={intervalInDays} one="day" other="days" />
                    &nbsp;to invited user, over a {timePeriod} day time period
                </>
            }
            placement={placement}
        />
    );
};
